import { Button, Card, Col, Divider, Form, Input, List, message, Row, Space, Table, Typography } from "antd"
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import garment_img from '../../../assets/dashboard/garment_img.png'
import { useLocation, useNavigate } from "react-router";
import ManageGarmentService from "../../../services/ManageGarmentService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const ViewGarment = () => {

    const [displayGarment, setDisplayGarment] = useState([]);
    const [binId, setBinId] = useState();
    const [kanbanEdit, setKanbanEdit] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const binLocation = decodeURIComponent(queryParams.get('bin_location') || '');

        const userdata = JSON.parse(localStorage.getItem("userData"));
        if (userdata.data.dept === "20" && binLocation.includes("dispatch_center")) {
            setKanbanEdit(true);
        }
            
        const fetchGarmentByBinId = async () => {
            
            const binIdFromQuery = queryParams.get('bin_id');

 
            if (binIdFromQuery) {
                setBinId(binIdFromQuery);

                try {
                    const response = await ManageGarmentService.getGarmentBybinId(binIdFromQuery);
                    setDisplayGarment(response.data);
                    
                    const data = response.data;

                    const transformedData = data.flatMap((item) => {
                        const sizeQty = JSON.parse(item.size_qty);
                        return Object.entries(sizeQty)
                            .filter(([size, qty]) => qty)
                            .map(([size, qty]) => ({
                                kanban_no: item.kanban_no,
                                size,
                                qty: Number(qty),
                            }));
                    });

                    // setDisplayGarment(transformedDataWithId);
                    console.log(response.data);


                } catch (error) {
                    console.error(error);
                }
            }
        };

        fetchGarmentByBinId();
    }, [location.search]);

    // console.log(binId);
    // console.log('size_qty:', displayGarment);

    const handleAddGarment = (garmentData) => {
        console.log("Received garment Data in Dashboard:", garmentData);

        setDisplayGarment((prevGarments) => {
            const updatedGarment = [...prevGarments, garmentData];
            console.log("Updated garment Collection:", updatedGarment);
            return updatedGarment;
        });
    };

    const handleEditGarment = (editedData) => {
        console.log(editedData);
        navigate(`/manage-bin/edit/garment?bin_id=${encodeURIComponent(binId)}&kb_num=${encodeURIComponent(editedData.kanban_no)}`);
    };

    const handleDeleteGarment = async (garmentData) => {
        try {
            const updatedGarments = [...displayGarment];
            const indexToDelete = updatedGarments.findIndex(
                (garment) => garment.dbd_id === garmentData.dbd_id
            );

            if (indexToDelete !== -1) {
                updatedGarments.splice(indexToDelete, 1);
                setDisplayGarment(updatedGarments); // Update the UI optimistically
            }

            console.log("Attempting to delete Kanban with dbd_id:", garmentData.dbd_id);

            // Call the service
            const response = await ManageGarmentService.deleteKanbanbyDbd_id(garmentData.dbd_id);
            if (response) {
                ResponseMessage.success({ message: response.message })
            } else {
                ResponseMessage.warning({ message : "No response received from deleteKanbanbyDbd_id service."});
            }
        } catch (error) {
            console.error("Error in handleDeleteGarment:", error);
            ResponseMessage.error({ message : "Failed to delete Kanban." });
        }
    };


    const handleArrowClick = () => {
        navigate(`/manage-bin`);
    };

    const handleAddGarments = () => {
        navigate(`/manage-bin/add-garment?bin_id=${encodeURIComponent(binId)}`);
    };

    const formText = {
        inputStyle: {
            color: 'black',
            fontWeight: 'bold'
        }
    };
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                    onBack={() => window.history.back()}
                >
                    <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />View Garments
                </Typography.Title>
                <Button type="primary" onClick={handleAddGarments}>Add Garment</Button>
            </div>
            <Divider style={{ marginTop: 8 }} />
            {/* setIsModalOpen(true) */}

            <div style={{ padding: '16px' }}>
                {displayGarment.length > 0 ? (
                    <Row gutter={[16, 16]}>
                        {displayGarment.map((garment) => {
                            const sizeData = JSON.parse(garment.size_qty);

                            const filteredSizeData = Object.keys(sizeData)
                                .filter((size) => sizeData[size] && Number(sizeData[size]) > 0)
                                .reduce((acc, size) => {
                                    acc[size] = sizeData[size];
                                    return acc;
                                }, {});

                            const sizeColumns = Object.keys(filteredSizeData).map((size) => ({
                                title: size,
                                dataIndex: size,
                                key: size,
                            }));

                            return (
                                <Col xs={24} sm={12} lg={8} key={garment.dbd_id}>
                                    <Card title={
                                        <>
                                            Kanban No: <span style={formText.inputStyle}>{garment.kanban_no}</span>
                                        </>
                                    }
                                        size='small'
                                        bordered>
                                        <div style={{ textAlign: 'center' }}>
                                            <img
                                                src={garment_img}
                                                alt="Garment"
                                                style={{ width: '40%', height: '40%', objectFit: 'cover' }}
                                            />
                                        </div>
                                        <div style={{ maxWidth: 300 }}>
                                            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                <Form.Item label="Item No" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.item_no} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="PO No" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.po_no} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Country" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.country || `No Data`} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Total Qty" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.total_qty} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Color" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.color} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                            </Space>
                                        </div>

                                        <Table
                                            size='small'
                                            columns={sizeColumns}
                                            dataSource={[filteredSizeData]}
                                            pagination={false}
                                            bordered
                                            rowKey={() => garment.dbd_id}
                                        />
                                        {kanbanEdit && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                                                <Button type="default" onClick={() => handleEditGarment(garment)}>
                                                    Edit
                                                </Button>
                                                <Button type="primary" danger onClick={() => handleDeleteGarment(garment)}>
                                                    Delete
                                                </Button>
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', color: 'gray' }}>
                        <p>No data found</p>
                    </div>
                )}
            </div>

        </>
    );
};
export default ViewGarment;